<template>
    <kgr-form-scaffold
        :pending="pending"
        @primaryBtnClicked="addArea"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-area-create-form
            :area="area"
            :error="error"
            @enter="addArea"
        />
    </kgr-form-scaffold>
</template>

<script>

import Area from '../../js/dto/resource/Area';
import AreaBasicDataForm from '../../components/resource/AreaBasicDataForm';
import AreaRepository from '../../js/repository/AreaRepository';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import Location from '../../js/dto/resource/Location';

export default {
    components: {
        'kgr-area-create-form': AreaBasicDataForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        areaId: {
            type: String,
        },
        locationId: {
            type: String,
            required: true,
        },
        overviewUrl: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            area: new Area(),
            location: new Location(),
            error: new Error()
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onAreaLoaded(loadedArea) {
            this.area = loadedArea;
        },
        addArea() {
            if (this.pending) {
                return;
            }

            this.pending = true;

            AreaRepository.create(this.area, this.locationId)
                .then(id => {
                    this.$notify.success('Bereich wurde erstellt', {}, { saveInSession: true });
                    window.location = `/backend/resources/locations/${this.locationId}/areas/${id}/edit`;
                })
                .catch(error => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}



</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
